import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray, reduxForm, formValueSelector } from 'redux-form';
import * as validators from 'utils/validators';
import InputField from 'components/InputField';
import { connect } from 'react-redux';
import * as actions from 'modules/account';
import { injectIntl } from 'react-intl';
import DateTimeField from 'components/DateTimeField';
import AlertDialog from 'components/AlertDialog';
import CollapsablePanel from './CollapsePanel';
import Locations from './Locations';
import moment from 'moment';
import ConfirmForm from './ConfirmForm';
import SupportWidget from '../pages/SupportWidget';
import { canUseFeature } from '../../config/pricing';
class ProfileForm extends ConfirmForm {

    showRevertDialog() {
        this.dialogConfirmRevert.show();
    }


    closeConfirmRevertDialog() {
        this.dialogConfirmRevert.hide();
    }


    revertSystem() {
        let { dispatch, currentInvoiceDate } = this.props;
        this.unregisterUnloadPrompt();
        dispatch(actions.revertSystem(currentInvoiceDate));
    }

    componentDidMount() {

        if (typeof window !== "undefined") {
            SupportWidget();

            let windowEl = (function () {
                var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
                function scroll() {
                    return { left: scrollLeft, top: scrollTop };
                };
                function scrollLeft() {
                    return window.scrollX || window.pageXOffset || (isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft);
                };
                function scrollTop() {
                    return window.scrollY || window.pageYOffset || (isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop);
                };
                return {
                    scroll: scroll,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                }
            })();

            let handle = setInterval(() => {
                let scrollY = windowEl.scrollTop();
                if (scrollY !== 0)
                    window && window.scrollTo(0, 0);
                else clearInterval(handle);

            }, 800);
        }
    }

    render() {
        let { initialValues, pristine, submitFailed, submitting, handleSubmit, onSubmit, intl, dispatch, accounting, taxes, hasMultipleLocations, locations, profile, valid, currentInvoiceDate } = this.props;
        const t = (id) => intl.formatMessage({ id });

        initialValues.styles = initialValues.styles || {};

        let disabled = pristine || submitting || initialValues.reverting;
        let hasChanges = !disabled;

        return (<div>
            <style>{`
      
            textarea{
                font-size:10px;
                font-family:Consolas,Monaco,Lucida Console,Liberation Mono,DejaVu Sans Mono,Bitstream Vera Sans Mono,Courier New;
                background-color: beige;
                border: none;
            }
            
            `}</style>

            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="ib-card">
                    <div className="ib-form-grid">
                        <div className="ib-span-2">
                            <div className="form-group">
                                <label htmlFor="profile.name">{t('bookkeeping.owner')}</label>
                                <Field
                                    className="form-control"
                                    name="profile.name"
                                    id="profile.name"
                                    component={InputField}
                                    type="text"
                                    validate={[validators.required, validators.maxLength150]}
                                />
                            </div>
                        </div>
                        <div className="form-group">
                                <label htmlFor="email">{t('bookkeeping.email')}</label>
                                <Field
                                    className="form-control"
                                    name="email"
                                    id="email"
                                    component={InputField}
                                    type="text"
                                    validate={[validators.required, validators.email, validators.disposableEmail]}
                                />
                            </div>
                        <div className="form-group">
                                <label htmlFor="phone">{t('bookkeeping.phone')}</label>
                                <Field
                                    className="form-control"
                                    name="phone"
                                    id="phone"
                                    component={InputField}
                                    type="text"
                                    validate={[validators.required]}
                                />
                            </div>
                    </div>
                </div>

                <div className="ib-card">
                    <div className="checkbox">
                        <label title={profile.profile && profile.profile.subscription !== 'professional' ? 'Multiple locations feature can be used only with Professional plan.' : 'Keep different invoices for each store location'} htmlFor="hasMultipleLocations">
                            <Field disabled={profile.profile && profile.profile.subscription !== 'professional'} parse={value => !!value} name="hasMultipleLocations" id="hasMultipleLocations" component="input" type="checkbox" />{t('bookkeeping.keepDifferentNumbering')}</label>
                    </div>
                    {profile.profile && profile.profile.subscription !== 'professional' && <div className="ib-banner" role="status">
                        <i className="fa fa-info-circle ib-banner-icon" aria-hidden="true"></i>
                        <div>
                            <p className="ib-banner-title">{t('bookkeeping.keepDifferentNumberingDisabled')}</p>
                            <p>{t('bookkeeping.locationEmailDesc')}</p>
                            <button type="button" className="btn btn-default btn-sm" onClick={() => { window ? window.location.href = 'billing' : () => { } }}>{t('bookkeeping.upgradePlan')}</button>
                        </div>
                    </div>}
                    {hasMultipleLocations && profile.profile && profile.profile.subscription === 'professional' && <div className="ib-card-section">
                        <div className="form-group">
                            <label htmlFor="match">{t('bookkeeping.matchingCriteria')}</label>
                            <Field className="form-control" name="match" id="match" component="select">
                                <option value="location_id">{t('bookkeeping.locationId')}</option>
                                <option value="shipping_address.country_code">{t('bookkeeping.shippingCountryCode')}</option>
                                <option value="billing_address.country_code">{t('bookkeeping.billingCountryCode')}</option>
                            </Field>
                            <p className="help-block">{t('bookkeeping.matchLocationDesc')}</p>
                        </div>
                        <FieldArray name="locations" user={initialValues} showLabels={false} locations={locations || []} dispatch={dispatch} component={Locations} />
                    </div>}
                </div>

                {!hasMultipleLocations && <div>
                    <CollapsablePanel location="default" section="company" title={t('bookkeeping.companyInfo')}>
                        <div className="ib-form-grid">
                            <div className="form-group">
                                <label htmlFor="company">{t('bookkeeping.name')}</label>
                                <Field
                                    className="form-control"
                                    name="company"
                                    id="company"
                                    component={InputField}
                                    type="text"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="website">{t('bookkeeping.website')}</label>
                                <Field
                                    className="form-control"
                                    name="website"
                                    id="website"
                                    component={InputField}
                                    type="text"
                                    validate={[validators.url]}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="registrationNumber">{t('bookkeeping.registrationNumber')}</label>
                                <Field
                                    className="form-control"
                                    name="registrationNumber"
                                    id="registrationNumber"
                                    component={InputField}
                                    type="text"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="taxId">{t('bookkeeping.taxId')}</label>
                                <Field
                                    className="form-control"
                                    name="taxId"
                                    id="taxId"
                                    component={InputField}
                                    type="text"
                                />
                            </div>
                        </div>
                        <h3 className="ib-subheading">{t('bookkeeping.addressSection')}</h3>
                        <div className="ib-form-grid">
                            <div className="form-group">
                                <label htmlFor="address.street">{t('bookkeeping.streetName')}</label>
                                <Field
                                    className="form-control"
                                    name="address.street"
                                    id="address.street"
                                    component={InputField}
                                    type="text"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="address.number">{t('bookkeeping.streetNumber')}</label>
                                <Field
                                    className="form-control"
                                    name="address.number"
                                    id="address.number"
                                    component={InputField}
                                    type="text"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="address.zip">{t('bookkeeping.zip')}</label>
                                <Field
                                    className="form-control"
                                    name="address.zip"
                                    id="address.zip"
                                    component={InputField}
                                    type="text"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="address.city">{t('bookkeeping.city')}</label>
                                <Field
                                    className="form-control"
                                    name="address.city"
                                    id="address.city"
                                    component={InputField}
                                    type="text"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="address.region">{t('bookkeeping.region')}</label>
                                <Field
                                    className="form-control"
                                    name="address.region"
                                    id="address.region"
                                    component={InputField}
                                    type="text"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="address.country">{t('bookkeeping.country')}</label>
                                <Field
                                    className="form-control"
                                    name="address.country"
                                    id="address.country"
                                    component={InputField}
                                    type="text"
                                />
                            </div>
                        </div>
                        <h3 className="ib-subheading">{t('bookkeeping.bankingInfo')}</h3>
                        <div className="ib-form-grid">
                            <div className="form-group">
                                <label htmlFor="bank.name">{t('bookkeeping.bankName')}</label>
                                <Field
                                    className="form-control"
                                    name="bank.name"
                                    id="bank.name"
                                    component={InputField}
                                    type="text"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="bank.swift">{t('bookkeeping.swift')}</label>
                                <Field
                                    className="form-control"
                                    name="bank.swift"
                                    id="bank.swift"
                                    component={InputField}
                                    type="text"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="bank.currency">{t('bookkeeping.currency')}</label>
                                <Field
                                    className="form-control"
                                    name="bank.currency"
                                    id="bank.currency"
                                    component={InputField}
                                    type="text"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="bank.iban">{t('bookkeeping.iban')}</label>
                                <Field
                                    className="form-control"
                                    name="bank.iban"
                                    id="bank.iban"
                                    component={InputField}
                                    type="text"
                                />
                            </div>
                        </div>
                    </CollapsablePanel>

                    <CollapsablePanel location="default" section="invoicing" title={t('bookkeeping.invoicing')}>
                        <div className="ib-form-grid">
                            <div className="form-group">
                                <label htmlFor="invoicePrefix">{t('bookkeeping.invoicesPrefix')}</label>
                                <Field
                                    className="form-control"
                                    name="invoicePrefix"
                                    id="invoicePrefix"
                                    component={InputField}
                                    type="text"
                                    validate={[validators.prefix]}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="currentInvoiceNumber">{t('bookkeeping.currentInvoiceNumber')}</label>
                                <Field
                                    className="form-control"
                                    name="currentInvoiceNumber"
                                    id="currentInvoiceNumber"
                                    component={InputField}
                                    type="text"
                                    defaultValue={initialValues.currentInvoiceNumber}
                                    validate={[validators.num]}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="creditNotePrefix">{t('bookkeeping.creditNotesPrefix')}</label>
                                <Field
                                    className="form-control"
                                    name="creditNotePrefix"
                                    id="creditNotePrefix"
                                    component={InputField}
                                    type="text"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="currentCreditNoteNumber">{t('bookkeeping.currentCreditNoteNumber')}</label>
                                <Field
                                    className="form-control"
                                    name="currentCreditNoteNumber"
                                    id="currentCreditNoteNumber"
                                    component={InputField}
                                    type="text"
                                    defaultValue={initialValues.currentCreditNoteNumber}
                                    validate={[validators.num]}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="decimalPlaces">{t('bookkeeping.decimalPlaces')}</label>
                                <Field
                                    className="form-control"
                                    name="decimalPlaces"
                                    id="decimalPlaces"
                                    component={InputField}
                                    type="text"
                                    defaultValue={initialValues.decimalPlaces}
                                    validate={[validators.positive_num]}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="currentInvoiceDate">{t('bookkeeping.lastInvoiceDate')}</label>
                                {initialValues.currentInvoiceDate ?
                                    <div>
                                        <Field
                                            className="form-control"
                                            name="currentInvoiceDate"
                                            component={DateTimeField}
                                            type="text"
                                            defaultValue={new Date(initialValues.currentInvoiceDate)}
                                            validate={[validators.required]}
                                        />
                                        <AlertDialog
                                            ref={instance => {
                                                this.dialogConfirmRevert = instance
                                            }}
                                            onOk={this.revertSystem.bind(this)}
                                            onClose={this.closeConfirmRevertDialog}
                                            dialogTitle={t('bookkeeping.confirmReverting')}
                                            message={`${t('bookkeeping.allInvoicesAfter')} ${moment(currentInvoiceDate).format('MM/DD/YYYY h:mm A')} ${t('bookkeeping.willBeRemoved')}`}
                                            closeButtonLabel={t('bookkeeping.cancel')}
                                            submitButtonLabel={t('bookkeeping.revert')} />
                                        <button title={t('bookkeeping.revertDesc')} type="button" className="btn btn-sm btn-danger ib-revert-button" onClick={this.showRevertDialog.bind(this)}>{initialValues.reverting ? t('bookkeeping.reverting') : t('bookkeeping.revertToDate')}</button>
                                    </div>
                                    : <p className="help-block">{t('bookkeeping.noInvoicesYet')}</p>}
                            </div>
                        </div>

                        <div className="ib-checkbox-list">
                            <div className="checkbox">
                                <label htmlFor="useOrderNumbering"><Field parse={value => !!value} name="useOrderNumbering" id="useOrderNumbering" component="input" type="checkbox" />{t('bookkeeping.useOrderNumbering')}</label>
                            </div>
                            <div className="checkbox">
                                <label htmlFor="showVTA"><Field parse={value => !!value} name="showVTA" id="showVTA" component="input" type="checkbox" />{t('bookkeeping.showVat')}</label>
                            </div>
                            {canUseFeature(profile.profile && profile.profile.subscription, 'taxOverride') ? <div>
                                <div className="checkbox">
                                <label htmlFor="taxes.override"><Field parse={value => !!value} name="taxes.override" id="taxes.override" component="input" type="checkbox" />{t('bookkeeping.overrideTaxes')}</label>
                            </div>
                                {taxes && taxes.override && <div className="ib-nested-fields">
                                    <div className="checkbox">
                                <label htmlFor="taxes.taxesIncluded"><Field parse={value => !!value} name="taxes.taxesIncluded" id="taxes.taxesIncluded" component="input" type="checkbox" />{t('bookkeeping.pricesIncludeTax')}</label>
                            </div>
                                    <div className="ib-form-grid">
                                        <div className="form-group">
                                            <label htmlFor="taxes.productsRate">{t('bookkeeping.productsTaxRate')}</label>
                                            <Field className="form-control" name="taxes.productsRate" id="taxes.productsRate" component={InputField} type="number" validate={[validators.positive_num]} />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="taxes.shippingRate">{t('bookkeeping.shippingTaxRate')}</label>
                                            <Field className="form-control" name="taxes.shippingRate" id="taxes.shippingRate" component={InputField} type="number" validate={[validators.positive_num]} />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="taxes.skus">{t('bookkeeping.skusSeparated')}</label>
                                            <Field placeholder="1234;2345;" className="form-control" name="taxes.skus" id="taxes.skus" component={InputField} type="text" />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="taxes.skuRate">{t('bookkeeping.skusTaxRate')}</label>
                                            <Field className="form-control" name="taxes.skuRate" id="taxes.skuRate" component={InputField} type="number" validate={[validators.positive_num]} />
                                        </div>
                                    </div>
                                </div>}
                            </div> : <div className="checkbox">
                                <label className="ib-disabled-option"><input type="checkbox" disabled /> {t('bookkeeping.overrideTaxes')} <span className="label label-info">Professional</span></label>
                            </div>}
                            {initialValues.autoInvoicingMode === 'manual' && <div className="checkbox">
                                <label htmlFor="useOrderDate"><Field parse={value => !!value} name="useOrderDate" id="useOrderDate" component="input" type="checkbox" />{t('bookkeeping.useOrderDates')}</label>
                            </div>}
                            <div className="checkbox">
                                <label htmlFor="convertPricesToBuyerCurrency"><Field parse={value => !!value} name="convertPricesToBuyerCurrency" id="convertPricesToBuyerCurrency" component="input" type="checkbox" />{t('bookkeeping.convertCurrency')}</label>
                            </div>
                        </div>
                    </CollapsablePanel>
                </div>}

                <div className={pristine ? "save-panel save-panel-contextual" : "save-panel save-panel-contextual visible"}>{t('bookkeeping.unsavedChanges')}</div>
                <div className="ib-save-actions" style={{ pointerEvents: pristine ? 'none' : 'auto' }}>
                    {!pristine && <button type="button" onClick={() => location.reload()} className="btn btn-default btn-sm">{t('bookkeeping.discard')}</button>}
                    <button id="save-changes" style={{ opacity: pristine ? 0 : 1 }}
                        className={(!pristine || submitFailed) && !valid ? "btn btn-danger btn-sm" : "btn btn-success btn-sm"}
                        type="submit"
                        title={(!pristine || submitFailed) && !valid ? "Form has invalid fields, check if all required fields are filled" : t('bookkeeping.save')}
                        disabled={pristine || submitting || initialValues.reverting} >
                        {t('bookkeeping.save')}
                    </button>
                </div>
                <i style={{
                    position: 'fixed',
                    top: '20px',
                    left: '13px',
                    zIndex: '99999997',
                    fontSize: '23px',
                    color: 'white'

                }} onClick={() => {
                    window.location.href = '/' + this.props.intl.locale + '/dashboard';
                }
                } className="back-button fa fa-arrow-circle-left">&nbsp;</i>
            </form>


        </div>);
    }
}


ProfileForm.PropTypes = {
    onSubmit: PropTypes.func.isRequired,
}

let ProfileFormComponent = reduxForm({ form: "Profile" })(injectIntl(ProfileForm));
ProfileFormComponent = connect(state => {
    const connectors = selector(state, 'connectors');
    const accounting = selector(state, 'accounting');
    const taxes = selector(state, 'taxes');
    const hasMultipleLocations = selector(state, 'hasMultipleLocations');
    const locations = selector(state, 'locations');
    const themes = selector(state, 'themes');

    const currentInvoiceDate = selector(state, 'currentInvoiceDate');
    return {
        connectors,
        accounting,
        currentInvoiceDate,
        hasMultipleLocations,
        locations,
        themes,
        taxes
    }
})(ProfileFormComponent)
const selector = formValueSelector('Profile');

class Profile extends Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {
        let { dispatch } = this.props;

        dispatch(actions.fetchAccount());
    }

    onSubmit(account) {
        let { dispatch } = this.props;
        dispatch(actions.updateAccount(account));
    }
    render() {

        let { account, intl, profile } = this.props;

        if (!account || !account.email) {
            return <div style={{
                position: 'absolute',
                top: '0',
                left: '50%'
            }}>{intl.formatMessage({ id: 'common.loading' })}</div>
        }

        return <div className="container-fluid">
            <div className="sidebar">
                <div className="col-md-10">
                    <span style={{ marginLeft: '23px' }}>{intl.formatMessage({ id: 'bookkeeping.title' })}</span>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12 ib-settings-page">

                    <ProfileFormComponent onSubmit={this.onSubmit.bind(this)} initialValues={account} profile={profile} />

                </div>
            </div>
        </div>

    }
}

Profile.propTypes = {
    account: PropTypes.object,
    dispatch: PropTypes.func.isRequired
};

function mapStateToProps(state) {

    return {
        ...state.user,
        account: {
            ...state.account
        },
        profile: state.form.Profile ? state.form.Profile.values : {},
    };
}

export default injectIntl(connect(mapStateToProps)(Profile));




// WEBPACK FOOTER //
// app/containers/Bookkeeping.jsx